module.exports = __webpack_public_path__ + "static/media/Gor 2018.10.12-1.9913b8fb.jpg";